import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import ComingSoon from "./images/coming-soon.svg";
import InfoIcon from "./images/info-icon.svg";
import { cmsURl } from "../../../constants/url-constants";
import { smallImage } from "../../../constants/image-constant";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

const CommingSoonDetail = ({bodyType = "", fullScreenGallery = false }) => {
    const imageSrc = smallImage[bodyType.toLowerCase()] || smallImage.sedan;

    const trackEvent = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.COMING_SOON_DETAIL_INFO);
    };

    return (
        <div  styleName={`styles.imageWrap ${fullScreenGallery ? "styles.fullScreenGallery" : ""}`} >
            <img src={imageSrc} styleName="styles.carImage"/>
            <div styleName={"styles.comingSoonWrap"}>
                <img styleName={"styles.comingSoonImg"} src={ComingSoon} alt="Coming Soon" />
            </div>
            <h5 styleName="styles.bottomStrip">
                <a href={`${cmsURl()}/pages/coming-soon`} target="_blank" onClick={trackEvent}>
                    <img src={InfoIcon} alt="Ready" />
                  READY WITHIN 7 DAYS
                </a>
            </h5>
        </div>
    );
};

CommingSoonDetail.propTypes = {
    bodyType: PropTypes.string,
    fullScreenGallery: PropTypes.bool
};

export default CommingSoonDetail;
